import { useState } from 'react';
import { Plus, Users2 } from 'lucide-react';

import { usePermissionCatalog, useUsers } from '@/api/hooks/useUsers';
import { Can } from '@/auth/guards';
import { PERMISSIONS } from '@/auth/permissions';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { UserCard } from '@/features/staff/UserCard';
import { UserFormDialog } from '@/features/staff/UserFormDialog';

export function StaffPage() {
  const { data: users, isLoading: usersLoading } = useUsers();
  const { data: catalog, isLoading: catalogLoading } = usePermissionCatalog();
  const [formOpen, setFormOpen] = useState(false);

  const isLoading = usersLoading || catalogLoading;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl">Staff & permissions</h1>
          <p className="text-sm text-muted-foreground">
            {users ? `${users.length} account(s)` : 'Loading…'}
          </p>
        </div>
        <Can permission={PERMISSIONS.usersManage}>
          <Button onClick={() => setFormOpen(true)}>
            <Plus /> Add staff member
          </Button>
        </Can>
      </div>

      {isLoading ? (
        <div className="space-y-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-16" />
          ))}
        </div>
      ) : !users || !catalog || users.length === 0 ? (
        <Card>
          <CardContent className="flex flex-col items-center gap-2 py-16 text-center">
            <Users2 className="h-8 w-8 text-muted-foreground/40" />
            <p className="text-sm text-muted-foreground">No staff accounts yet.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-2">
          {users.map((user) => (
            <UserCard key={user.id} user={user} catalog={catalog} />
          ))}
        </div>
      )}

      <UserFormDialog open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
}